import { jwtDecode } from "jwt-decode";
import atividadeService from "@/service/atividadeService";

export default {
  getUserInfos() {
    //retorna todas as informações contidas no token('email', 'nome', 'userId' e 'scope')
    const token = window.localStorage.getItem("auth_token");
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        return decodedToken;
      } catch (error) {
        console.error("Erro ao decodificar o token:", error);
      }
    }
  },
  tokenExpirado(token) {
    if (!token) return true;
    try {
      if (!token.exp) return true;
      return Date.now() > token.exp * 1000;
    } catch (e) {
      return true; // token inválido
    }
  },

  async verificarLiderancaAtividade(atividadeId) {
    try {
      // Verifica se o usuário logado é líder da atividade
      const grupo = await atividadeService.getGrupoAtividade(atividadeId);
      const usuario = this.getUserInfos().nome;

      // Verificação mais segura
      if (!grupo || !grupo.Membros || !Array.isArray(grupo.Membros)) {
        return false;
      }

      return grupo.Membros.some((membro) => {
        return (
          usuario === membro.nome &&
          membro.regras &&
          Array.isArray(membro.regras) &&
          membro.regras.some((regra) => {
            return regra.nome === "LIDER";
          })
        );
      });
    } catch (error) {
      console.error("Erro ao verificar liderança:", error);
      return false;
    }
  },
};
